import { mdiNoteEdit, mdiNoteEditOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { IconProps } from '.'

const NoteIcon = (props: IconProps) => {
    const { filled, color, size = 1, title, ...other } = props
    return (
        <Icon
            data-testid="IconButton__Note"
            path={filled ? mdiNoteEdit : mdiNoteEditOutline}
            title={title}
            size={size}
            color={color}
            {...other}
        />
    )
}

export default NoteIcon
